import  ApiDataService  from './ApiDataService'

const sendTeacherEmail = data => {
  return ApiDataService.post("teacheremail", data);
};


export default {sendTeacherEmail};